import React, { useEffect, useState } from "react";
import "./DatabaseInsight.css";
import "../../Page.css";
import DatabaseHealth from "../../../Components/DatabaseInsightComponents/DatabaseHealth/DatabaseHealth";
import connectionsIcon from "../../../Assets/Images/connections.png";
import databaseIcon from "../../../Assets/Images/database.png";
import timeIcon from "../../../Assets/Images/time.png";
import restartIcon from "../../../Assets/Images/restart.png";
import { FaChartLine } from "react-icons/fa";
import heapIcon from "../../../Assets/Images/heap.png";
import cpuIcon from "../../../Assets/Images/cpu.png";
import totalRequestIcon from "../../../Assets/Images/requests.png";
import insertOptionIcon from "../../../Assets/Images/insertop.png";
import readLatencyIcon from "../../../Assets/Images/readlatency.png";
import writeLatency from "../../../Assets/Images/writelatency.png";
import nodeLogo from "../../../Assets/Images/node.png";
import redisLogo from "../../../Assets/Images/redis.png";
import mongodbLogo from "../../../Assets/Images/mongoDB.png";
import serverSize from "../../../Assets/Images/serversize.png";
import axios from "axios";
import { security_key, Url } from "../../../Services/Api";
import BottomToust from "../../../Components/BottomToust/BottomToust";

const DatabaseInsight = () => {
  const [databaseData, setDatabaseData] = useState();
  const [serverData, setServerData] = useState();
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServerAndDatabaseData = async () => {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };
      setError(null);
      const api = `/api/metrics`;
      try {
        const response = await axios.get(Url + api, { headers: headers });
        console.log("database and server data", response);
        setDatabaseData(response.data.database);
        setServerData(response.data.server);
        setToastMessage("Database Performance data have been fetched successfully!");
        setShowMessage(true);
      } catch (error) {
        const errMsg = error?.response?.data?.message || error.message;
        setError(errMsg);
        setToastMessage(`Failed to fetch Database Perfromance data: ${errMsg}`);
        setShowMessage(true);
      }

    };
    fetchServerAndDatabaseData();
  }, []);

  const analyticCardData = [
    {
      name: "Total Request",
      icon: totalRequestIcon,
      duration: "Last 7 Days",
      analyticalValue: databaseData?.totalRequests,
      analyticGroth: "20.23",
    },
    {
      name: "Insert Operations",
      icon: insertOptionIcon,
      duration: "Last 7 Days",
      analyticalValue: databaseData?.opcounters?.insert,
      analyticGroth: "20.23",
    },
    {
      name: "Read Latency",
      icon: readLatencyIcon,
      duration: "Last 7 Days",
      analyticalValue: databaseData?.opLatencies?.reads?.avgLatency?.value,
      units: databaseData?.opLatencies?.writes?.avgLatency?.unit,
      analyticGroth: databaseData?.opLatencies?.reads?.avgLatency?.status,
    },
    {
      name: "Write Latency",
      icon: writeLatency,
      duration: "Last 7 Days",
      analyticalValue: databaseData?.opLatencies?.writes?.avgLatency?.value,
      units: databaseData?.opLatencies?.writes?.avgLatency?.unit,
      analyticGroth: databaseData?.opLatencies?.writes?.avgLatency?.status,
    },
  ];

  const serverDataObj = [
    {
      name: "CPU",
      icon: cpuIcon,
      value: serverData?.cpuUsage?.totalCPU?.value,
      unit: serverData?.cpuUsage?.totalCPU?.unit,
      status: serverData?.cpuUsage?.totalCPU?.status,
    },
  ];

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  return (
    <div className="DashboardPage">
      <div className="database-and-server-insight-main-container">
        <DatabaseHealth
        id={0}
          title={"Database Health"}
          typeLogo={mongodbLogo}
          timeCardTitle={"Up Time"}
          time={databaseData?.uptime}
          cardData={[
            {
              title: "Connections",
              icon: connectionsIcon,
              valueOne: databaseData?.connections?.current,
              valueTwo:
                databaseData?.connections?.available +
                databaseData?.connections?.current,
            },
            {
              title: "Database Size",
              icon: databaseIcon,
              valueOne: databaseData?.storage?.storageSize,
              valueTwo: databaseData?.storage?.allocated,
              unit: databaseData?.storage?.storageSizeUnit,
              unitTwo: databaseData?.storage?.allocatedUnit,
            },
          ]}
          cardLength={2}
          cardTitle={"Connection"}
          cardIcon={connectionsIcon}
          valueOne={20}
          valueTwo={50}
          analyticData={analyticCardData}
          analyticTitle={"Total Order"}
          analyticDuration={"Last 7 Days"}
          analyticValue={236}
          analyticGroth={20.23}
          analyticIcon={<FaChartLine />}
          analyticWidth={"100%"}
        />

        <DatabaseHealth
        id={1}
          title={"Server Health"}
          typeLogo={nodeLogo}
          timeCardTitle={"Up Time"}
          time={serverData?.uptime}
          cardData={[
            {
              title: "Server Size",
              icon: serverSize,
              valueOne: serverData?.usedMemory.value,
              unit: serverData?.usedMemory.unit,
              valueTwo: serverData?.totalMemory?.value,
              unitTwo: serverData?.totalMemory?.unit,
            },
            {
              title: "HEAP",
              icon: heapIcon,
              valueOne: serverData?.heapUsed.value,
              unit: serverData?.heapUsed.unit,
              valueTwo: serverData?.heapTotal?.value,
              unitTwo: serverData?.heapTotal?.unit,
            },
            { title: "Restart Count", icon: restartIcon, timeCount: 20 },
            { title: "Down time", icon: timeIcon, timeCount: "00:10:00" },
          ]}
          cardLength={1}
          cardTitle={"Connection"}
          cardIcon={connectionsIcon}
          valueOne={20}
          valueTwo={50}
          serverData={serverDataObj}
          userAndSystemData={serverData?.cpuUsage}
          analyticTitle={"Total Order"}
          analyticDuration={"Last 7 Days"}
          analyticValue={236}
          analyticGroth={20.23}
          analyticIcon={<FaChartLine />}
          analyticWidth={"100%"}
        />

      </div>
      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
    </div>
  );
};

export default DatabaseInsight;